var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManualEntrIcs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4 10H14.6C11.9601 10 10.6402 10 9.8201 10.8201C9 11.6402 9 12.9601 9 15.6C9 18.2398 9 19.5598 9.8201 20.3798C9.91116 20.4709 10.0084 20.5519 10.1129 20.6238H12.4217C12.7029 20.3156 13.1463 20.059 13.4742 19.8693C13.5503 19.8252 13.6202 19.7848 13.6804 19.7482C15.0996 18.8839 16.9004 18.8839 18.3196 19.7482C18.3798 19.7848 18.4497 19.8252 18.5258 19.8693C18.8537 20.059 19.2971 20.3156 19.5783 20.6238H21.8871C21.9916 20.5519 22.0888 20.4709 22.1799 20.3798C23 19.5598 23 18.2398 23 15.6C23 12.9601 23 11.6402 22.1799 10.8201C21.3598 10 20.0398 10 17.4 10ZM17.75 15.6C17.75 16.5665 16.9665 17.35 16 17.35C15.0335 17.35 14.25 16.5665 14.25 15.6C14.25 14.6335 15.0335 13.85 16 13.85C16.9665 13.85 17.75 14.6335 17.75 15.6Z",
    fill: "#2C8C53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1129 20.6238C10.0084 20.5519 9.91116 20.4709 9.8201 20.3798C9 19.5598 9 18.2398 9 15.6C9 12.9601 9 11.6402 9.8201 10.8201C10.6402 10 11.9601 10 14.6 10H17.4C20.0398 10 21.3598 10 22.1799 10.8201C23 11.6402 23 12.9601 23 15.6C23 18.2398 23 19.5598 22.1799 20.3798C22.0888 20.4709 21.9917 20.5519 21.8871 20.6238",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6808 19.7481C13.0756 20.1166 11.4888 20.8692 12.4553 21.8109C12.9274 22.2709 13.4532 22.5999 14.1143 22.5999H17.8865C18.5476 22.5999 19.0734 22.2709 19.5455 21.8109C20.512 20.8692 18.9252 20.1166 18.32 19.7481C16.9008 18.8838 15.1 18.8838 13.6808 19.7481Z",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 15.5998C17.75 16.5663 16.9665 17.3498 16 17.3498C15.0335 17.3498 14.25 16.5663 14.25 15.5998C14.25 14.6334 15.0335 13.8499 16 13.8499C16.9665 13.8499 17.75 14.6334 17.75 15.5998Z",
    stroke: "#172B4D",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualEntrIcs);
export default __webpack_public_path__ + "static/media/manual_entr_ics.6c157b0f2ba7e563b71028e432f0e092.svg";
export { ForwardRef as ReactComponent };